import { configureStore } from '@reduxjs/toolkit'
import testingReducer from './reducers/testingSlice.js';
import likesReducer from './reducers/likesSlice.js';
import durationReducer from './reducers/durationSlice.js';
import resultRecommendationsReducer from './reducers/resultRecommendationsSlice';
import resultReducer from './reducers/resultSlice';
import testRatingReducer from './reducers/testRatingSlice';
import testRatingFormReducer from './reducers/testRatingFormSlice';
import authReducer from './reducers/authSlice';
import historyResultReducer from '@/store/reducers/historyResultSlice';
import addDomainReducer from '@/store/reducers/addDomainSlice';
import domainsListReducer from '@/store/reducers/domainsListSlice';
import createWidgetSlice from '@/store/reducers/createWidgetSlice';
import reportFormSlice from '@/store/reducers/reportFormSlice';
import pageReducer from '@/store/reducers/pageSlice';

const isProduction = process.env.NODE_ENV === 'production';

const store = configureStore({
    reducer: {
        page: pageReducer,
        testing: testingReducer,
        reportForm: reportFormSlice,
        likes: likesReducer,
        duration: durationReducer,
        resultRecommendations: resultRecommendationsReducer,
        result: resultReducer,
        testRating: testRatingReducer,
        testRatingForm: testRatingFormReducer,
        auth: authReducer,
        historyResult: historyResultReducer,
        widgetNewDomain: addDomainReducer,
        widgetDomainsList: domainsListReducer,
        createWidget: createWidgetSlice,
    },

    devTools: !isProduction,
})


export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;